// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowSmallUpIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowSmallUpIcon" ref={forwardedRef} {...props}>
      <path d="M5.507 9.993 9.75 5.75l4.243 4.243-1.061 1.06L9.75 7.871l-3.182 3.182z" />
      <path d="M10.5 7.254v6H9v-6z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowSmallUpIcon = /* @__PURE__ */ Object.assign(
  ArrowSmallUpIconComponent,
  { displayName: 'ArrowSmallUpIcon' },
);
